import React, { useCallback } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useGetEventCTAButtonsDataLazyQuery } from '@graphql/generated';
import { useCtaButtons } from '@apps/guest/packages/layout-engine/common/utils/useCtaButtons';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Rsvp } from '@withjoy/joykit/icons';

export const EditRSVPAction: React.FC = () => {
  const { eventHandle, eventInfo } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { t } = useTranslation('guestGuide');
  const [getCtaData, { data: sessionData, called: calledCTA, loading: loadingCTA }] = useGetEventCTAButtonsDataLazyQuery({
    batchMode: 'fast',
    ssr: false,
  });

  React.useEffect(() => {
    if (eventHandle) {
      getCtaData({
        variables: { name: eventHandle },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventHandle]);

  const handleClick = useCallback(() => {
    telemetry.clickEditRsvp();
  }, [telemetry]);

  const { getButtonsVisibility } = useCtaButtons();
  const { welcomePage, storyPage, tidbitsPage, schedulePage, travelPage, faqPage, weddingPage, registryPage, momentsPage, rsvpPage, customPages } = sessionData?.eventByName || {};
  const { eventCTA } = sessionData?.eventByName?.activeSession || {};
  const { rsvpIsEnabled, scheduleHasInviteOnlyItems } = eventCTA || {};
  const pages = [welcomePage, storyPage, tidbitsPage, schedulePage, travelPage, faqPage, weddingPage, registryPage, momentsPage, rsvpPage, ...(customPages ?? [])];
  const rsvpIsPasswordProtected = rsvpPage?.private;
  const { shouldDisplayUnlockButton } = getButtonsVisibility(pages, welcomePage, schedulePage, rsvpIsEnabled, rsvpIsPasswordProtected, scheduleHasInviteOnlyItems, false);

  if (loadingCTA || !calledCTA || !eventInfo || rsvpPage?.disabled === true || shouldDisplayUnlockButton) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<Rsvp />}
      as="a"
      href={`/${eventHandle}/rsvp`}
      onClick={handleClick}
    >
      {t('buttonTextEditRSVP')()}
    </GuestGuideActionButton>
  );
};
